import { NavLink, Outlet } from 'react-router-dom';
import { useAuthContext } from '../auth/auth0-provider';
import { config } from '../runtime-config';
import { LoadingBlock } from './ui';
import { Button } from '../neon/controls';

export function AppLayout() {
  const { authEnabled, isAuthenticated, isLoading, user, login, logout } = useAuthContext();

  return (
    <>
      <header className="app-header">
        <NavLink className="powerschool-link" to="/">
          <span className="powerschool-mark" aria-hidden="true">▥</span>
          <strong>Powerschool</strong>
        </NavLink>
        <span className="header-divider" aria-hidden="true">/</span>
        <span className="product-name">Naviance Provisioning Hub</span>
        <div className="header-right">
          {authEnabled && isAuthenticated ? (
            <>
              <span className="who">{user?.email || user?.nickname || user?.name}</span>
              <Button id="app-signout" text="Sign out" variant="secondary" onClick={logout} />
            </>
          ) : (
            <span className="who">acting as {config.staffUsername} (local dev)</span>
          )}
        </div>
      </header>

      <div className="app-body">
        <aside className="sidebar" aria-label="Primary navigation">
          <nav>
            <NavLink className="sidebar-link" to="/" end><span aria-hidden="true">▦</span> District and Schools</NavLink>
            <button className="sidebar-link" type="button"><span aria-hidden="true">▱</span> Colleges</button>
            <button className="sidebar-link" type="button"><span aria-hidden="true">✣</span> Admin <span className="sidebar-chevron">⌄</span></button>
            <NavLink className="sidebar-link sidebar-staff" to="/staff"><span aria-hidden="true">♙</span> Staff Accounts</NavLink>
          </nav>
        </aside>
        <main className="crm-app-container">
        {authEnabled && isLoading ? (
          <LoadingBlock label="Checking your session…" />
        ) : authEnabled && !isAuthenticated ? (
          <div className="card">
            <p>You need to sign in to use the CRM.</p>
            <Button id="app-signin" text="Sign in with Auth0" onClick={login} />
          </div>
        ) : (
          <Outlet />
        )}
        </main>
      </div>
    </>
  );
}
